var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"indexPage"}},[_c('div',{staticClass:"content-wrap"},[_c('homeBanner'),_c('coreCapablity'),_c('solution'),_c('productionSolution'),_c('achievment'),_c('cooperationDemo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }